import { getFeatureFlagsKey } from 'api/FeatureFlags/queryKeys';
import { getFeatureFlagsGetRequest } from 'api/FeatureFlags/requests';
import { useAxiosQuery } from 'api/useAxiosQuery';
export var useFeatureFlags = function useFeatureFlags() {
    var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {}, enabled = _ref.enabled;
    return useAxiosQuery(getFeatureFlagsKey(), function () {
        return getFeatureFlagsGetRequest();
    }, {
        enabled: enabled
    });
};
/**
 * Hook returns true if features were loaded.
 * Assumes that by ensuring the result is a non-null object.
 * Queries data already prefetched by flags provider.
 */
export var useAreFeaturesLoaded = function useAreFeaturesLoaded() {
    var _useFeatureFlags = useFeatureFlags({
        enabled: false
    }), isFetched = _useFeatureFlags.isFetched;
    return isFetched;
};
